// This file is auto-generated. Do not edit!

export default [
  {
    address: "0x06A63c498eF95AD1fA4FfF841955e512b4B2198a",
    symbol: "GLUTEU",
  },
  {
    address: "0xB9C0769332337bb5899C358e0eb7BC8d95faA903",
    symbol: "ppppa",
  },
  {
    address: "0x32Cd26bcd05e8d42bA72E117F5A28B0b3Df7DF9D",
    symbol: "4a6dca4077d484b995ff8891f5361a5a",
  },
  {
    address: "0x9886c579dF16362a213C866e3ef7ACD9a4F956E3",
    symbol: "WT",
  },
  {
    address: "0x396227eDABf114c1ddE1Da1e96537a8F8204946d",
    symbol: "CHIBI",
  },
  {
    address: "0x63E939C1c139C8F477a53a2AF6BB3810959Ea199",
    symbol: "GEKKOU",
  },
  {
    address: "0xd6A2B3B84489020737E9058c549108F5C4b7830d",
    symbol: "GEKKOU",
  },
  {
    address: "0x9a960Cf8a8242B895CEC756F12da6faef09Eac30",
    symbol: "RBase",
  },
  {
    address: "0x959143611C63C1fa693A2e0771eD122D1574F576",
    symbol: "test2",
  },
  {
    address: "0x0CeC55550de5282ee833Be61031ebd7862db28D9",
    symbol: "WAGMI",
  },
  {
    address: "0xAC0B7A9a46D7E072086C066341FB5f2978E45832",
    symbol: "KEKERL",
  },
  {
    address: "0x70819f1a8b2e9D7279b8353c316c15a8fb66755b",
    symbol: "BUNNY",
  },
  {
    address: "0x1999390e3E222252e933CfEF2a9C7754d2A85A40",
    symbol: "CLANKPRINT",
  },
  {
    address: "0x18C77ecf929eD923E87315FdD2d76Ec2D9EBe793",
    symbol: "basedAI",
  },
  {
    address: "0x4224C9f46316A40f46Eb35516330b959cDFD5DCE",
    symbol: "$Hobbes",
  },
  {
    address: "0xf54D1bF5FF3457d6812E6826D549A939302612Ae",
    symbol: "CASINO",
  },
  {
    address: "0x151D317F9Ba14e84BAB42c7436768898C7BBF8AF",
    symbol: "PRICETEST",
  },
  {
    address: "0x72Fd6907113101e6E32CEE25D5909868504d67F1",
    symbol: "LAMA",
  },
  {
    address: "0x16794331AD76EC31ACF1601D32a695471e9DBae7",
    symbol: "GME",
  },
  {
    address: "0x21D00CbB0D572FF0E46945C54d607466601923EF",
    symbol: "PEPE",
  },
  {
    address: "0xE579070CA0BCa2797779801d081313c30c43FaD8",
    symbol: "KITTY",
  },
  {
    address: "0xa3fd8C75aA9731777C61256350FfdfA6743f023a",
    symbol: "CR7",
  },
  {
    address: "0xA2e6df88D18979bee480f75503e4d5778201cF24",
    symbol: "GME",
  },
  {
    address: "0x071AA252276561DB778537e52BF44eAEF0647b8a",
    symbol: "RoaringKitty",
  },
  {
    address: "0xaeAc53804d63093b9303a9561776C1A87Baef922",
    symbol: "FLOKI",
  },
  {
    address: "0x0b417Dc9229fE70363BE176b6551656cc2E796D4",
    symbol: "LANDO",
  },
  {
    address: "0x3F232E64b7a921C926342624FEA03DF0425C1D2C",
    symbol: "DUMB",
  },
  {
    address: "0x3f7fcE849158E81BA1F1B6b3B5ccfAD502F23d28",
    symbol: "SAYLOR",
  },
  {
    address: "0xFeb3fC2AF053724B2d5854bE0Fc63fC8cE1e6185",
    symbol: "RoaringKitty",
  },
  {
    address: "0x795F165c1A7c7454b9076fF371e4301A3C075402",
    symbol: "BASE",
  },
  {
    address: "0xF168D8F456Ce511C1490b28c615b73385ac37AB6",
    symbol: "GIGGLE",
  },
  {
    address: "0xAB9b9608Ba2D9cc8CB50227a3814AF2C873B6F95",
    symbol: "CONSENSYS",
  },
  {
    address: "0xEc5F27D91D342D4B9B79354e6911a720dc0359F6",
    symbol: "bstn",
  },
  {
    address: "0x81e1F12da1120017Ce51B55201ca8a70Cd477Eee",
    symbol: "MYN",
  },
  {
    address: "0x573E7CB643DFed69049f39b08cf82B958C26d90C",
    symbol: "",
  },
  {
    address: "0xCC849f8603c460528F664a4D8bdcCe56a4528a54",
    symbol: " ͚̥̹̘͖̱̮̘̬̳̹̫̬̰̗͕̮̜͖͓̱̥̥͎͕͍͓̮̞̤͇̰͖̘̻̳̠̩̥̙̯̯̥͍̗̙̠̪̝̰̼̰̤̘͉̭̖͉̝̩̣͇̙̞͎̫̖̤̫̩̯̪̭̤̳͈̳̳̙͎͔͉̩̻̻͈̟̻̦͉͙͔̰̜͚̭͖̮͐̓ͨ́̎̍͆̄̒̍̄̽͗̎ͮͬ͒̇ͨ̌̃̈́̓̂͂̿͛̄͐́̀͑͂̐̇̔ͥ̀̅̆̽ͪ͌̂̀ͧ̽̈̍̾̈͌̂͌̇ͪ́̒̀̅ͯ̿ͯ̆̔͊ͦ͒̆ͥͣ̀ͭ̿̒̑̈ͧͩ̄͌͊ͮ̾̒ͮ̎͂ͨ̐ͥ̍͂̆͆͆̂̚ͅ ͙̜̬̯̠͍̖͇̞̥̘̙͔̗̼̯̜͉͚̳̗͙͓̻̝͎̟̜̱͇̫͔̳̭̟̠̲̫͎̲̥̤̖͙̱̥̗̫͈͙̙̹̠̲̱̦̩̲͎̪̬̼̠̗̙̹̰͖͈̞̦̻̼͓͔̮̞͖͇͇̘̺̞̣͖̠̜̖͖̤̦͔͈̘͉͙ͬ̾ͧ̃́͌ͯͫ̂̃͊͒ͥ̉̐͊̐͗̈̍̎̃͆͒̎̀̓̽̎̊ͪ͋̐̓̊̎ͮ̀̂̋ͦ͗̆͌ͯͤ̈́ͨ̒ͧ̓͒̌̈̎̇ͪ̅́̑̂̉̉ͫ̆ͨ͌ͧ̅͌ͧ́͊̂ͨ̑̽͌ͭ̾ͣͪ̿̌̈̒̉̑̀͗̑̋ͨ̅ͦͯ͑ͅͅͅ ̥͎͉͇͔̬̤̹͇̟͙̬̬̮̰̠͍͓̻͎͍͙̯͍̬͎̺̞͔͕̘̤̥̱̜̝̮͇̣͎̩̱͈͓̙̗̟͓̗͎̠̯̠͔̫̰̲̯͎̜͈̻͍̭̟̰͓̮̩̰̰͙͕̹̰̘͎̼̹͍͔̯̯̻̖͙͇̲͎̗̮̭̘̣̞͍̮ͤͯͧ͌ͩ̔ͣ̎͌ͤ̄̃̽̒ͧ̋̃̇͊͌̒̓ͯ̏̆̔ͣ̽̂͑ͭ̒ͧͥͯ̔ͤͩͫ͐̋͆́͌̓ͨ̿ͩ͋̎̆̊̌̑́ͦ͆ͥͪͣ̅͗̋̓͋̌̀ͤͪ̐̐̃̾ͬͯͪͯͦͧ̌̌͋͂ͮ͆̆̉ͫ̒ͬ̿͂̎͌͊̚̚̚ͅͅ",
  },
  {
    address: "0xf1942A8ac6e9123997289c621Dced13049705895",
    symbol:
      " ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏  ͏  ͏ ͏ ͏  ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏ ͏ ͏ ͏  ͏ ͏",
  },
  {
    address: "0x346b930bB1C2C97C8327EC7369909C4e6d79b7f1",
    symbol: "TRUMP",
  },
  {
    address: "0x9DC85be17A61344C0cc31A03C0A3336F0b4A001E",
    symbol: "POW",
  },
  {
    address: "0x9c2eb3046cee6D0dD1b4e12aAa43D74235e6EAc0",
    symbol: "꙰⃝꙰⃝꙰⃝꙰⃝꙰⃝꙰⃝꙰",
  },
  {
    address: "0xE82D84f3f1ACa689f1F775991c9Beeea37fB0653",
    symbol: "꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂꧁꧂",
  },
  {
    address: "0x9F7965de7180E7D7D6b55F8f67BC41bC6a4e30a6",
    symbol: "‮",
  },
  {
    address: "0xD8a45F06b0efa4D4dba41d71d85C16DD0F134eeB",
    symbol: ".ۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗۗەÎ̂̂̂̂̂̂",
  },
  {
    address: "0x71890863661a3876F4f6C755dE127deE272dCB28",
    symbol: "WILL",
  },
  {
    address: "0x494112Ae80cce36D9bB5eB5158334aa68C2eE519",
    symbol: "🔒",
  },
  {
    address: "0x3f6a984fba958276AADdc474ec007396588E0f6f",
    symbol: "PEPE",
  },
  {
    address: "0x8c6828Da22E63823d49A723838f9BBce34D7bdB0",
    symbol: "DJT",
  },
  {
    address: "0xd84D6728e154F7121AfA7aFDe009470c476E5854",
    symbol: "MOTHER",
  },
  {
    address: "0xfA2405944C1e33F6b857A4E1EAf67eD8654300b9",
    symbol: "MOG",
  },
  {
    address: "0xcbceD314d16A236BEB73a1940C67CCa34B4cE64b",
    symbol: "PEPE",
  },
  {
    address: "0xa559a3534324D3C294c7b9eB64C505514484DDa6",
    symbol: "boden",
  },
  {
    address: "0x205658E5B4655Bf5c27d8D133EF377E52AA631e0",
    symbol: "hypememe.fun",
  },
  {
    address: "0xF16439030646A3956Daf3E2456F5E31B3e88594f",
    symbol: "D.O.G.E.",
  },
  {
    address: "0xF44562e1B79cB0a7a1e26edc71BD50Eddf240C13",
    symbol: "D.O.G.E.",
  },
  {
    address: "0x34f4a8efCB8ff833a8052E1C0725324b947ab3A0",
    symbol: "MVP",
  },
  {
    address: "0xACA13F2fc468E6DE15269D38484B588Bbb0bA887",
    symbol: "MAGA",
  },
  {
    address: "0xeF6E6B6090B5eBc55504A3AeB8A0cB3C9d914909",
    symbol: "WIF",
  },
  {
    address: "0xdCA716B7360B76383E8f7B82AeFCbe632fC381af",
    symbol: "DUCK",
  },
  {
    address: "0x19bF54d64bc776532fF03937b662226E4af59517",
    symbol: "MAGA",
  },
  {
    address: "0xddEb793839e4c2b5FfE80008DE7f4521da67Cab4",
    symbol: "BSE",
  },
  {
    address: "0x13137B72bC9822bD2800086187033693017023A6",
    symbol: "VLOGGER",
  },
  {
    address: "0xB2AfbDc55E277FeaD5c54f28Dc5468B2766e7147",
    symbol: "PEPT",
  },
  {
    address: "0x8c3ed1f4D142965D19e0DB48Ae189dd9448Ad95A",
    symbol: "WOT",
  },
  {
    address: "0x48Acb1C1F8e3932AFA3de104495e86c5A6fC843C",
    symbol: "WZD",
  },
  {
    address: "0x3155C5F16d706F4F4ae5E5f8B98eC33905c0e06b",
    symbol: "BSTST",
  },
  {
    address: "0x0fdFd509C7D8b57aeC45EaC41cabe8987e41226d",
    symbol: "clonk",
  },
  {
    address: "0x315077bd45617a5965bEA7FeF1018276b19c8d62",
    symbol: "BSo",
  },
  {
    address: "0x5fF986De80Fc8502eA9293B8c06EF22b1e3f11e9",
    symbol: "BINU",
  },
  {
    address: "0x96D3f37DBEC31b763Ac0a08Ef620027B94FB023a",
    symbol: "COD",
  },
  {
    address: "0xC4B60B342f636B244326545d18DEe198Cca75a52",
    symbol: "CONSENSYS",
  },
  {
    address: "0xFe0c0B15798B8c9107CD4aa556A87Eb031263e8b",
    symbol: "AETX",
  },
  {
    address: "0x6392C932085b016eA8C9c5cF457F2008Ce623AC6",
    symbol: "TOIN",
  },
  {
    address: "0xe1f916E805F0E8ce0eE643882BA5eDA2639a8190",
    symbol: "OPIUM",
  },
  {
    address: "0x06BAf524E01229A63B21939002142f68Ce7f8F00",
    symbol: "Kekius",
  },
  {
    address: "0x0419856F551fec5AA8a18d2A05090A93BbE62071",
    symbol: "ARTTO",
  },
  {
    address: "0x313f2cdDcdc74747C18D2F529ec9c087860198Ed",
    symbol: "AHD",
  },
  {
    address: "0x189b5576CFd40c615B3c309BA5D393Bb0b6Ab849",
    symbol: "$SNPDOGE",
  },
  {
    address: "0x221D4820602ce80F486a3b6348e364F32D14550b",
    symbol: "GALA",
  },
  {
    address: "0xe911c12104A21C296c4CBb282E2A43D55305dEe1",
    symbol: "KENZO",
  },
  {
    address: "0x550161Ae735DebeE90Ba117025db0E83131bf9A6",
    symbol: "LUMIA",
  },
  {
    address: "0x1a9f53a3237dD66047eb560BC81d4Fd2D28dBfD2",
    symbol: "fred",
  },
  {
    address: "0xF4C20d2B42Cc6d8e4277f8257229c79994E587c3",
    symbol: "$JUP",
  },
  {
    address: "0x4200000000000000000000000000000000000006",
    symbol: "WETH",
  },
  {
    address: "0xd60626fc36E149558F47E8fd6955cA6144cA9638",
    symbol: "ROBINHOOD",
  },
  {
    address: "0x176F0BC7A5d2FC01396B6b5432A15893FcADbAb0",
    symbol: "TEST3",
  },
  {
    address: "0x62406e7c5d2B6a981473840bAba44416f763E267",
    symbol: "ZUCKERBERG",
  },
  {
    address: "0x529215d022d2dE79aF93245B97f5a3AdE693B605",
    symbol: "🧢MAGACoin",
  },
  {
    address: "0x850a4c4d71bE9C09A682Cd13A01FEA3E544e4cA0",
    symbol: "Bera",
  },
  {
    address: "0xCfbDAA56F1945e377fFdF38a5612c37f48819927",
    symbol: "TRUMP",
  },
  {
    address: "0x5325FB838317734F9988C09a28667ACeed01B06f",
    symbol: "BBRETT",
  },
  {
    address: "0x7050ea3088E5A3f2BE051073F477FcCca44f6710",
    symbol: "EURO24",
  },
  {
    address: "0x37eEE70E40Db681A884C754260B2aFD416595653",
    symbol: "ARC",
  },
  {
    address: "0x578D3a95b63D10C2aA870EEAe862EAdd5232525e",
    symbol: "PEPE",
  },
  {
    address: "0x55782f9c2C8Dd6f5be673826C9fb0039584E5D4B",
    symbol: "BBB",
  },
  {
    address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    symbol: "USDC",
  },
  {
    address: "0xF8fA6ef4aCA0B431Da07FEfe88c32e4D5080Ae91",
    symbol: "H.J.Res.109",
  },
  {
    address: "0xB4A89255574Fd3410ED4F218eE22d68D891393b7",
    symbol: "FLOKI",
  },
  {
    address: "0x0cd64F5eF133A8be645199ccF82b203707ceC4af",
    symbol: "DEP",
  },
  {
    address: "0x03e8Ff316E741ca0C184689651B39904CC76b0C5",
    symbol: "RoaringKitty",
  },
  {
    address: "0x48ADE9b80277705D092803b58b6d241de91232d0",
    symbol: "BASEOVER",
  },
  {
    address: "0x694B593A9E58376ad69b5d3f71c9d94894fe467B",
    symbol: "flETH",
  },
  {
    address: "0x2dBB0a5937C7bBfe139420BdDcBFDA0fFF74575F",
    symbol: "Banana",
  },
  {
    address: "0x7c9179e29093B0667EB8faE4B477298002dda567",
    symbol: "TRUMP",
  },
  {
    address: "0x2a00830D28A5c9Fd219184c74bEF13E43ECB12b8",
    symbol: "VERSTAPPEN",
  },
  {
    address: "0xE18Ce0C83f978E863B81B0662Cc0e2132e86eeED",
    symbol: "TREAT",
  },
  {
    address: "0x7d7421b7CeEF650065dCD7F9950C08591a5cB417",
    symbol: "PARAM",
  },
  {
    address: "0x3d533590b816B69943878121678860C31DDedb8D",
    symbol: "BASE",
  },
  {
    address: "0x949E7b96C3946A0A035d33094FcB58418d50c505",
    symbol: "USDN",
  },
  {
    address: "0x12E78f1dAcf2A916E9E7f3b4f38081Ab115FcDF9",
    symbol: "SEA",
  },
  {
    address: "0xb74B7afc123F58787886D9e65E86D17FbDD78e17",
    symbol: "OFFICIAL",
  },
  {
    address: "0x2296278321c0Bb58422d77226cD6ca0759b18480",
    symbol: "PEPE",
  },
  {
    address: "0x2b72C608264bC6CaEfdf7231fC917e0318488043",
    symbol: "MACD",
  },
  {
    address: "0x5c5EbFa9ffE0D09c2b9F3e1d802c5Ff2Ff2Dd5fe",
    symbol: "NORRIS",
  },
  {
    address: "0x75c8Cad4f60193f19342Ebc116a19a8e49B6B2A5",
    symbol: "SBF",
  },
  {
    address: "0xFbd2b48988C04AeBAC38E60d79e8746d1fBc095D",
    symbol: "PHIL",
  },
  {
    address: "0xA4705aA2Dc6aFB9f19BA046C78365E448427a7C3",
    symbol: "MEME",
  },
  {
    address: "0x1fF8db61e8238B4eEedced6381c492921CEbA7D8",
    symbol: "EURO24",
  },
  {
    address: "0xa8334525aA440A27826B915547F32F7f9D0b0503",
    symbol: "DOGE",
  },
  {
    address: "0x27Fe662Cf97925992222e1c184161b5745C50305",
    symbol: "WLFI ",
  },
  {
    address: "0xfF1C4FE43c23710ca9eDc611833519e186B9A4e2",
    symbol: "PHA",
  },
  {
    address: "0xA73614E5984a71a86145CD444Ab82e7A1525974b",
    symbol: "NVDA",
  },
  {
    address: "0x9Ab65Bd2Ecf44fd7c79E434A939774d16bc95aaA",
    symbol: "FREE",
  },
  {
    address: "0xD8A476519e5924f33617B3ec361Fe803694e52e8",
    symbol: "doginme",
  },
  {
    address: "0x83964F6624232D63bCcB20CBC8FCF16298996f0E",
    symbol: "CHX",
  },
  {
    address: "0xE0E634A863f582B86BBAEfFfC3412D01DE186a39",
    symbol: "BASE",
  },
  {
    address: "0x3F455CA2eC49e11c6B1e128447Fa9E8E31Db559E",
    symbol: "SHIB",
  },
  {
    address: "0x801F3F79F57f92f9E4cE449348f94CAD63dC5fdC",
    symbol: "Bitcat",
  },
  {
    address: "0xeAC770a0767AE96582cb7422C22110cb961cD9F5",
    symbol: "RSR",
  },
  {
    address: "0xec454689f5c155950B66467cF4089A3F167825ca",
    symbol: "SIMONS",
  },
  {
    address: "0x189653502e697Dca5D6f1bF9D6fBc4fEBbA731c2",
    symbol: "ZUCKERBERG40",
  },
  {
    address: "0xCACE234fE8C19261Bb162e9cf453057092957910",
    symbol: "GMEKITTY",
  },
  {
    address: "0x5a0E63f38D1333357c0153943c4a0F13E225d1c0",
    symbol: "EURO",
  },
  {
    address: "0xbE17dfc2C6d26FeBe2aFc98ccB1EDFBB60854E91",
    symbol: "JOSEPH",
  },
  {
    address: "0x7e1C268C2B794C930cDf7b195869De0Ac94B0A21",
    symbol: "TRUMPDAY",
  },
  {
    address: "0xDF66508F76F97608DA6AE1b14c86eb3cB7b00ab4",
    symbol: "BOPCAT",
  },
  {
    address: "0x92Ac55D6Dd093490B0d816C4a78Cd2bE300D73fE",
    symbol: "HAREMBE X KABOSU",
  },
  {
    address: "0x7717a07581C727bA7c1511C573697b1EB791A30D",
    symbol: "FIDELITY",
  },
  {
    address: "0x094ca3354CeF66EDf1B20CA4890087BDc9616893",
    symbol: "KABOSU",
  },
  {
    address: "0x69a767D1727D125279Ce0eeb407491617526d906",
    symbol: "ROBINHOOD",
  },
  {
    address: "0xeDa6192C1C1F17187DfF12bED547F754142CADaF",
    symbol: "MICA",
  },
  {
    address: "0xF766b45c052AB92317409F55Fef54b056bc78c6a",
    symbol: "MAGA",
  },
  {
    address: "0x2e948aFCE4e42C382fBb409A3D2A600f81e79470",
    symbol: "YAMEL",
  },
  {
    address: "0xFCc2C5d8387dAFb5a986dAe8D3aA7861fd9292d9",
    symbol: "NVIDIA",
  },
  {
    address: "0xcdbB08fA2120e122879e7cf8914B37ec376612B3",
    symbol: "KABOSU",
  },
  {
    address: "0x479A9a51F164114F2aA903226015bd6eC3dE492c",
    symbol: "SWIFT",
  },
  {
    address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
    symbol: "cbBTC",
  },
  {
    address: "0x919a432445d89AD661B953119F040EcDAf9016F4",
    symbol: "PIZZA",
  },
  {
    address: "0x532f27101965dd16442E59d40670FaF5eBB142E4",
    symbol: "BRETT",
  },
  {
    address: "0xD5457DC852Bf0A1A3FD1fFfe9232D843B48FeEcc",
    symbol: "HALFIN",
  },
  {
    address: "0x291C57b7e29e8D035f42d68E2268f1B3ABe78407",
    symbol: "LUBIN",
  },
  {
    address: "0xc7799dfed9ec34e1D6E0D75fB56c284DDE40bAAc",
    symbol: "Trx",
  },
  {
    address: "0x0f2c1C448a11204f69f1CbC2535937C88537d434",
    symbol: "RNT",
  },
  {
    address: "0x0034E887cc70f67a9a54F31d1D5b52942dC6E965",
    symbol: "OBC",
  },
  {
    address: "0x71CB212754c8a13f0B5773e93497ef04d9c4E175",
    symbol: "HOPPY",
  },
  {
    address: "0x94bc124A87d4a171c09b07cd59be8dD7911c2609",
    symbol: "$78",
  },
  {
    address: "0xAC1Bd2486aAf3B5C0fc3Fd868558b082a531B2B4",
    symbol: "TOSHI",
  },
  {
    address: "0x6dc3d8FEe328CC54c46d3812d74a12aa739AabAB",
    symbol: "MAGANOMICS",
  },
  {
    address: "0x21186Cbb66dd349864B14c1210308b8839Be88BF",
    symbol: "EUR",
  },
  {
    address: "0x9E6A46f294bB67c20F1D1E7AfB0bBEf614403B55",
    symbol: "MAG7.ssi",
  },
  {
    address: "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b",
    symbol: "VIRTUAL",
  },
  {
    address: "0x0D87E5E17C68Dd5dc346797bF4036DfA0bc947C7",
    symbol: "PPEPE",
  },
  {
    address: "0xd93A0976acD731549AEe2f5Af721cB913c1Fd051",
    symbol: "JOSEPH",
  },
  {
    address: "0x0b78aFfC8e5E542E50b2247302fC89A71B8b7824",
    symbol: "🍻 BEER",
  },
  {
    address: "0x6921B130D297cc43754afba22e5EAc0FBf8Db75b",
    symbol: "doginme",
  },
  {
    address: "0x20fAD58A61c3B522FfDc819694D38653DCB0211F",
    symbol: "BLUEY",
  },
  {
    address: "0x67dd8404E609bb4F1bA81eae2cF2005d8160C0C1",
    symbol: "EURO24",
  },
  {
    address: "0x822330630F20C55FCdc15f680ab51EA3E868B861",
    symbol: "MEMEX",
  },
  {
    address: "0xBC69990A060cC5AF40942f579BdF82A69A9CFf93",
    symbol: "PVPB",
  },
  {
    address: "0x3B94604b9230112D9a0c409885F459e89f98D104",
    symbol: "TRUMP",
  },
  {
    address: "0xf7408a2c97b1003A29A8dDDcCdcfE44146f11749",
    symbol: "FOMO",
  },
  {
    address: "0x6B2504A03ca4D43d0D73776F6aD46dAb2F2a4cFD",
    symbol: "REI",
  },
  {
    address: "0xFD764f3f4d16047E090B9020C3a66bA86c767C5F",
    symbol: "MEMERBIT",
  },
  {
    address: "0x1B68244B100A6713ca7F540697b1bE12148a8bf9",
    symbol: "YES",
  },
  {
    address: "0x7ca4d45a2b7223f968c9C58C9a7Ad0704Dbf4890",
    symbol: "FULLSEND",
  },
  {
    address: "0x371f338D14ffAA5575241b458b94f3C0BF68469f",
    symbol: "💡 IDEA",
  },
  {
    address: "0xf08c9E741Ed575031aFF1972DD975d04fdFD1c4D",
    symbol: "BILLY",
  },
  {
    address: "0x50dA645f148798F68EF2d7dB7C1CB22A6819bb2C",
    symbol: "SPX",
  },
  {
    address: "0x1bc0c42215582d5A085795f4baDbaC3ff36d1Bcb",
    symbol: "CLANKER",
  },
  {
    address: "0x27D2DECb4bFC9C76F0309b8E88dec3a601Fe25a8",
    symbol: "BALD",
  },
  {
    address: "0x62AF5774B54D5186eF3f462fd6eD93BCe2B16e44",
    symbol: "CICADA",
  },
  {
    address: "0x2247Eddef722e8be039557422704FA20F9CC387A",
    symbol: "ai16z",
  },
  {
    address: "0xb14A3F8287D590B6aD9ABf1CC94f0AA3198fEE4D",
    symbol: "sec",
  },
  {
    address: "0x7f88F7FEa8D8A06acae239ED84c1d7A8D93A0475",
    symbol: "MAGA",
  },
  {
    address: "0x209b94Bb22C990D9d221749558c5FFEd7Fc82e64",
    symbol: "GAGSTER",
  },
  {
    address: "0x2f6c17fa9f9bC3600346ab4e48C0701e1d5962AE",
    symbol: "Fartcoin",
  },
  {
    address: "0xcB59edB40B86429e68535bf0EdbD0640F4771A47",
    symbol: "TAI",
  },
  {
    address: "0xb33Ff54b9F7242EF1593d2C9Bcd8f9df46c77935",
    symbol: "FAI",
  },
  {
    address: "0x55591D2E31d90e6E23A7eABe8DE68f312D0785A1",
    symbol: "Byebit",
  },
  {
    address: "0x2739e24841E6edCb51b0Ad3990761C2E73394F72",
    symbol: "LONG",
  },
  {
    address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
    symbol: "DEGEN",
  },
  {
    address: "0xA4b17e73A8a79c0227804eFDDBa298dc8aaa82C7",
    symbol: "COPA",
  },
  {
    address: "0x320155582cC96A7c52F42779B047f341a6859F71",
    symbol: "B5",
  },
  {
    address: "0x22aF33FE49fD1Fa80c7149773dDe5890D3c76F3b",
    symbol: "BNKR",
  },
  {
    address: "0x348409fa3651D4Cf8571dB6bDfaAdD3df35987cD",
    symbol: "BILLY",
  },
  {
    address: "0x17fBc025FD6a0C5913D6cB8213aF61E77a9ABE3c",
    symbol: "Real",
  },
  {
    address: "0xC526e51CB74bF3F60690De0465504dc640C2F10B",
    symbol: "MELANIA",
  },
  {
    address: "0xE3086852A4B125803C815a158249ae468A3254Ca",
    symbol: "$mfer",
  },
  {
    address: "0x777703eDD29D1cDB08bECb5feB50c5e3443fB90B",
    symbol: "RCR",
  },
  {
    address: "0xBDA6752d931f06895821756224CE42492630b15B",
    symbol: "PEPE",
  },
  {
    address: "0x25f7FfFF9aC0CFA346866C6Cc9F9DE1f69D62A22",
    symbol: "BRKFST",
  },
  {
    address: "0xe932099eC1e79246f4655E2c17266f745F20E767",
    symbol: "NUNU",
  },
  {
    address: "0x2960A147BbEC2a858366Ae4e94aA496012c69363",
    symbol: "LNCH",
  },
  {
    address: "0x22066D8264C0758FE020968759dF5F38B2C1F9ce",
    symbol: "ELON",
  },
  {
    address: "0x937a1cFAF0A3d9f5Dc4D0927F72ee5e3e5F82a00",
    symbol: "Cocoro",
  },
  {
    address: "0x09BCc244524CDdbc7446a993AE13Cd69928a68c2",
    symbol: "DISH",
  },
  {
    address: "0x4F9Fd6Be4a90f2620860d680c0d4d5Fb53d1A825",
    symbol: "AIXBT",
  },
  {
    address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
    symbol: "USDbC",
  },
  {
    address: "0xd977700eBFd90E143bD1eD1f18430A6047B5B3b0",
    symbol: "TTTest",
  },
  {
    address: "0x64bB89b07e5c1DcfB8e731916aD155C71A905684",
    symbol: "PEPE",
  },
  {
    address: "0x18297a3D5c4be0b020e58a162D3868B8A5b92362",
    symbol: "APTHV1",
  },
  {
    address: "0x5F2ac4465192243781a281a1ed023649811687F5",
    symbol: "BASE",
  },
  {
    address: "0x5eD8BA85D277C870EeE77EE7A628E94D18Bfe027",
    symbol: "Web3",
  },
  {
    address: "0x3B0973B5298Df83B81854eBfA8578d2c4586A20E",
    symbol: "SHIB",
  },
  {
    address: "0x012D089446c4098058727DC3CC1F9F1f73CC6B96",
    symbol: "NUGS",
  },
  {
    address: "0x940181a94A35A4569E4529A3CDfB74e38FD98631",
    symbol: "AERO",
  },
  {
    address: "0x9e91077EB43C26a92fe8c830A730CF582e011c34",
    symbol: "CRINGE",
  },
  {
    address: "0xABa939D544D8DbC5aF6bF442eEE2dAfa42202A1E",
    symbol: "NALS",
  },
  {
    address: "0xf7B31c8603d70CA22FF5a81Ea56430fd0C5145E0",
    symbol: "TRUMP",
  },
  {
    address: "0x53e1252C96B50F4a0B1D24f6C21b784E87b6e083",
    symbol: "Europe",
  },
  {
    address: "0x52b492a33E447Cdb854c7FC19F1e57E8BfA1777D",
    symbol: "PEPE",
  },
  {
    address: "0x3567D03a958494834C0ec9D5AE602251F6dDB3f6",
    symbol: "MAGA",
  },
  {
    address: "0xe9652C01B3a445fb1d2E91B3865a055Ea83eBd08",
    symbol: "DOGE",
  },
  {
    address: "0xA0aeBd4Ae5F256B72B7D43f67eD934237Adb1AeE",
    symbol: "BONSAICOIN",
  },
  {
    address: "0x566879525B07862708ef162c422eC70CA3FA8244",
    symbol: "OPRAH",
  },
  {
    address: "0xC06d667A6123aBB9133eB8996d551730c1f1055D",
    symbol: "EG",
  },
  {
    address: "0x346fAC947bc2e24Ab5D74a8BCa94082C6127B6C0",
    symbol: "KABOSU",
  },
  {
    address: "0x3ec2156D4c0A9CBdAB4a016633b7BcF6a8d68Ea2",
    symbol: "DRB",
  },
  {
    address: "0x8600afe41B35DaFa72E42Da9D633be48E64fb559",
    symbol: "KAMA",
  },
  {
    address: "0x9AC802B60b477CAe004f9938C3b7abE99899E194",
    symbol: "ETHV",
  },
  {
    address: "0xB1a03EdA10342529bBF8EB700a06C60441fEf25d",
    symbol: "MIGGLES",
  },
  {
    address: "0x70737489DFDf1A29b7584d40500d3561bD4Fe196",
    symbol: "BORED",
  },
  {
    address: "0x2C8C89C442436CC6C0a77943E09c8Daf49Da3161",
    symbol: "ZBU",
  },
  {
    address: "0xe487aBd2Af7ECB7CD597C9FF011a855C99191728",
    symbol: "WOW",
  },
  {
    address: "0x857aC97ea291cdF09AFE0f7e81204B0542631cEd",
    symbol: "TRUMPMANIA",
  },
  {
    address: "0x7Be3Fa9E1b934E26e95B4c3de6D4e1c0100F8Fa2",
    symbol: "PIZZA",
  },
  {
    address: "0x5d96a814600Ae9044312d7cE40C7c1c74D774f85",
    symbol: "DORAEMON",
  },
  {
    address: "0xC958E3db092Ce36105C14217BBFa38B90a9C3E78",
    symbol: "AIRDROP",
  },
  {
    address: "0x87f04a2935a0D84EAB8154bC134b53816ecdF6b3",
    symbol: "FREEDUROV",
  },
  {
    address: "0xD962E9bc39Cc9c4a6908cE4141bA54E82160f56d",
    symbol: "CLOWNX",
  },
] as const
